export const solease_lightblue = '#5FBADE'
export const solease_yellow = '#FFDB00'
export const solease_cultured = '#F8F8F8'
export const solease_gray = '#4F4F4F'
export const solease_gray_2 = '#C4C4C4'
export const solease_gray_3 = '#828282'
export const solease_light_gray = '#696969'
export const solease_red = '#FF0606'
